<div class="progress-indicator-line">
  <div class="progress-indicator-line-base"></div>
  <div
    class="progress-indicator-line-lead"
    [ngClass]="leadDynamicClass"
    [ngStyle]="leadWidth"></div>
</div>
